// extracted by mini-css-extract-plugin
export default {"container":"BoxLayout_container__JKehn"};